import { z } from "zod";
import { logisticsApi } from "./ApiClient";

export const aiSupportChatMessageSchema = z.object({
  id: z.string(),
  sessionId: z.string().nullable(),
  text: z.string(),
  type: z.enum(["user", "ai"]),
});

export type IAISupportChatMessage = z.infer<typeof aiSupportChatMessageSchema>;

const supportAgentResponseSchema = z.object({
  sessionId: z.uuid(),
  message: z.string(),
});

export async function startNewSession({ message }: { message: string }) {
  return await logisticsApi
    .post(`/conversion/support-agent/sessions`, {
      json: { message },
    })
    .json(supportAgentResponseSchema);
}

export async function sendMessageToSession({
  sessionId,
  message,
}: {
  sessionId: string;
  message: string;
}) {
  return await logisticsApi
    .put(`/conversion/support-agent/sessions/${sessionId}`, {
      json: { message },
    })
    .json(supportAgentResponseSchema);
}
